/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DirectoryCardPlatform
 */
export interface DirectoryCardPlatform {
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlatform
     */
    platform: DirectoryCardPlatformPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlatform
     */
    effectiveLiveState: DirectoryCardPlatformEffectiveLiveStateEnum;
    /**
     * 
     * @type {number}
     * @memberof DirectoryCardPlatform
     */
    viewerCount?: number;
    /**
     * 
     * @type {string}
     * @memberof DirectoryCardPlatform
     */
    streamTitle?: string;
}


/**
 * @export
 */
export const DirectoryCardPlatformPlatformEnum = {
    TWITCH: 'TWITCH',
    KICK: 'KICK',
    YOUTUBE: 'YOUTUBE'
} as const;
export type DirectoryCardPlatformPlatformEnum = typeof DirectoryCardPlatformPlatformEnum[keyof typeof DirectoryCardPlatformPlatformEnum];

/**
 * @export
 */
export const DirectoryCardPlatformEffectiveLiveStateEnum = {
    LIVE: 'LIVE',
    OFFLINE: 'OFFLINE',
    UNKNOWN: 'UNKNOWN'
} as const;
export type DirectoryCardPlatformEffectiveLiveStateEnum = typeof DirectoryCardPlatformEffectiveLiveStateEnum[keyof typeof DirectoryCardPlatformEffectiveLiveStateEnum];


/**
 * Check if a given object implements the DirectoryCardPlatform interface.
 */
export function instanceOfDirectoryCardPlatform(value: object): value is DirectoryCardPlatform {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    if (!('effectiveLiveState' in value) || value['effectiveLiveState'] === undefined) return false;
    return true;
}

export function DirectoryCardPlatformFromJSON(json: any): DirectoryCardPlatform {
    return DirectoryCardPlatformFromJSONTyped(json, false);
}

export function DirectoryCardPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): DirectoryCardPlatform {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'effectiveLiveState': json['effectiveLiveState'],
        'viewerCount': json['viewerCount'] == null ? undefined : json['viewerCount'],
        'streamTitle': json['streamTitle'] == null ? undefined : json['streamTitle'],
    };
}

export function DirectoryCardPlatformToJSON(json: any): DirectoryCardPlatform {
    return DirectoryCardPlatformToJSONTyped(json, false);
}

export function DirectoryCardPlatformToJSONTyped(value?: DirectoryCardPlatform | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'effectiveLiveState': value['effectiveLiveState'],
        'viewerCount': value['viewerCount'],
        'streamTitle': value['streamTitle'],
    };
}

